/* Home Living - shared storefront behaviour.
   Everything here is delegated from document, so it works for any section
   on the page and for markup that arrives later (Load more). */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     Quick add: the variant picker that opens on a product card
     --------------------------------------------------------- */

  /* The button that opened the picker currently on screen. Opening moves
     focus into the panel, so closing has to hand focus back - hiding a
     panel with focus inside it throws the keyboard user to the top of the
     document. */
  var lastOpener = null;

  function closeAllPickers(except) {
    var open = document.querySelectorAll('[data-hl-qa] [data-hl-qa-panel]:not([hidden])');
    for (var i = 0; i < open.length; i++) {
      var card = open[i].closest('[data-hl-qa]');
      if (card === except) { continue; }
      var btn = card.querySelector('[data-hl-qa-open]');
      /* read this BEFORE hiding the panel - hiding it blurs whatever is inside */
      var hadFocus = card.contains(document.activeElement);
      open[i].hidden = true;
      if (btn) { btn.setAttribute('aria-expanded', 'false'); }
      card.classList.remove('is-open');
      card.classList.remove('is-up');
      if (hadFocus) {
        var back = btn || lastOpener;
        if (back && document.contains(back)) { back.focus({ preventScroll: true }); }
      }
      if (lastOpener && card.contains(lastOpener)) { lastOpener = null; }
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }

    var opener = e.target.closest('[data-hl-qa-open]');
    if (opener) {
      var card = opener.closest('[data-hl-qa]');
      var panel = card.querySelector('[data-hl-qa-panel]');
      var wasOpen = !panel.hidden;
      closeAllPickers(card);
      panel.hidden = wasOpen;
      card.classList.toggle('is-open', !wasOpen);
      opener.setAttribute('aria-expanded', String(!wasOpen));

      /* if the panel would hang off the bottom of the screen, flip it above */
      if (!wasOpen) {
        lastOpener = opener;
        var box = panel.getBoundingClientRect();
        card.classList.toggle('is-up', box.bottom > window.innerHeight - 12);
        var first = panel.querySelector('.hl-qa__opt:not([disabled])') || panel.querySelector('button:not([disabled])');
        if (first) { first.focus({ preventScroll: true }); }
      } else {
        /* tapped the same button again: it closed, and focus belongs on it */
        lastOpener = null;
        opener.focus({ preventScroll: true });
      }
      return;
    }

    if (e.target.closest('[data-hl-qa-close]')) {
      closeAllPickers(null);
      return;
    }

    /* a click anywhere outside an open picker closes it */
    if (!e.target.closest('[data-hl-qa]')) {
      closeAllPickers(null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllPickers(null); }
  });

  /* ---------------------------------------------------------
     Load more: fetch the next page and append its cards
     --------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-hl-loadmore]') : null;
    if (!btn) { return; }

    e.preventDefault();
    var next = btn.getAttribute('data-hl-next');
    if (!next || btn.classList.contains('is-busy')) { return; }

    var gridSelector = btn.getAttribute('data-hl-target') || '.hl-cg__grid';
    /* stay inside the grid this button belongs to - a page can hold several */
    var scope = btn.closest('.hl-cg__main') || document;
    var grid = scope.querySelector(gridSelector);
    if (!grid) { return; }

    btn.classList.add('is-busy');
    var original = btn.textContent;
    btn.textContent = btn.getAttribute('data-hl-busy') || 'Loading...';

    fetch(next, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) { throw new Error('bad response'); }
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector(gridSelector);
        if (!incoming) { throw new Error('no grid'); }
        var docScope = incoming.closest('.hl-cg__main') || doc;

        var firstNew = null;
        while (incoming.firstElementChild) {
          var node = incoming.firstElementChild;
          incoming.removeChild(node);
          grid.appendChild(node);
          if (!firstNew) { firstNew = node; }
        }

        /* the "12 of 40 products" line has to move with the grid */
        var countNow = scope.querySelector('.hl-more__count');
        var countNext = docScope.querySelector('.hl-more__count');
        if (countNow && countNext) { countNow.textContent = countNext.textContent; }

        /* carry the next link forward, or retire the button */
        var nextBtn = docScope.querySelector('[data-hl-loadmore]');
        var nextUrl = nextBtn ? nextBtn.getAttribute('data-hl-next') : null;
        if (nextUrl) {
          btn.setAttribute('data-hl-next', nextUrl);
          btn.textContent = original;
          btn.classList.remove('is-busy');
        } else {
          var wrap = btn.closest('[data-hl-loadmore-wrap]') || btn;
          wrap.remove();
        }

        /* move focus to the first new card for keyboard and screen readers */
        if (firstNew) {
          var link = firstNew.querySelector('a[href]');
          if (link) { link.setAttribute('tabindex', '-1'); link.focus({ preventScroll: true }); }
        }

        var live = scope.querySelector('[data-hl-loadmore-status]');
        if (live) { live.textContent = 'More products loaded.'; }
      })
      .catch(function () {
        /* the plain pagination links are still in the page, so fall back to them */
        btn.classList.remove('is-busy');
        btn.textContent = original;
        window.location.href = next;
      });
  });
})();